import { ChevronDown, ChevronUp, Info } from 'lucide-react';

function CrawlCookieHelpToggle({ showCookieHelp, setShowCookieHelp }) {
  return (
    <button
      type="button"
      data-testid="crawl-cookie-help-toggle"
      onClick={() => setShowCookieHelp(!showCookieHelp)}
      className="flex items-center gap-1 text-xs text-blue-400 transition-colors hover:text-blue-300"
    >
      <Info className="h-3 w-3" />
      Comment obtenir les cookies ?
      {showCookieHelp ? <ChevronUp className="h-3 w-3" /> : <ChevronDown className="h-3 w-3" />}
    </button>
  );
}

function CrawlCookieHelpPanel({ showCookieHelp }) {
  if (!showCookieHelp) {
    return null;
  }

  return (
    <div className="space-y-2 rounded-sm border border-blue-800/50 bg-blue-900/20 p-3 text-xs text-zinc-300">
      <p className="font-medium text-blue-400">Étapes recommandées</p>
      <ol className="list-inside list-decimal space-y-1 text-zinc-400">
        <li>Connectez-vous au site dans votre navigateur.</li>
        <li>Ouvrez les DevTools puis l’onglet Application.</li>
        <li>Copiez les cookies du domaine concerné.</li>
        <li>Collez-les ici au format <code className="text-blue-300">nom=valeur; nom2=valeur2</code>.</li>
      </ol>
      <p className="text-zinc-500">Un export JSON depuis une extension dédiée fonctionne également.</p>
    </div>
  );
}

function CrawlCookieTextarea({ sessionCookies, setSessionCookies, crawling }) {
  return (
    <textarea
      id="sessionCookies"
      data-testid="session-cookies-input"
      value={sessionCookies}
      onChange={(event) => setSessionCookies(event.target.value)}
      placeholder="Format: nom=valeur; nom2=valeur2"
      disabled={crawling}
      rows={4}
      className="w-full resize-none rounded-sm border border-zinc-800 bg-zinc-900/50 px-4 py-3 font-mono text-sm text-white placeholder:text-zinc-600 transition-colors duration-300 focus:border-white focus:outline-none focus:ring-0"
    />
  );
}

export function CrawlCookieFields({
  sessionCookies,
  setSessionCookies,
  showCookieHelp,
  setShowCookieHelp,
  crawling,
}) {
  return (
    <div className="space-y-3">
      <div className="flex items-center justify-between">
        <label htmlFor="sessionCookies" className="text-sm font-medium">Cookies de session</label>
        <CrawlCookieHelpToggle showCookieHelp={showCookieHelp} setShowCookieHelp={setShowCookieHelp} />
      </div>
      <CrawlCookieHelpPanel showCookieHelp={showCookieHelp} />
      <CrawlCookieTextarea sessionCookies={sessionCookies} setSessionCookies={setSessionCookies} crawling={crawling} />
      <p className="text-xs text-green-600">Recommandé pour les sites avec SSO, Google Workspace ou authentification complexe.</p>
    </div>
  );
}
